import { red } from "@material-ui/core/colors";
import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";

export const primaryColor = "#0b148e";
export const secondaryColor = "#ffffff";
const defaultTheme = createMuiTheme();

// Customized global theme

export const customizedTheme = responsiveFontSizes(
  createMuiTheme({
    palette: {
      primary: {
        main: primaryColor,
      },
      secondary: {
        main: secondaryColor,
      },
      error: {
        main: red.A400,
      },
      background: {
        default: "#f7faff",
      },
      action: {
        selected: "#8e93b0",
        hover: "#E5E7FA;",
        disabled: "#8D93B3",
      },
    },
    overrides: {
      // TODO override style components
      MuiBackdrop: {
        root: {
          backgroundColor: "rgba(28, 38, 104, 0.26)",
          backdropFilter: "blur(10px)",
        },
      },
      MuiButton: {
        contained: {
          background: " #3246D3",
          borderRadius: "99px",
          textTransform: "none",
          fontSize: 14,
          fontWeight: 600,
          width: "auto",
          height: 48,
          padding: "0 20px",
        },
        text: {
          background: secondaryColor,
          textTransform: "none",
          borderRadius: "99px",
          color: "white",
          fontSize: 14,
          // lineHeight: 17,
          fontWeight: 600,
          height: 48,
          padding: "0 20px",
          "&:hover": {
            background: " #3246D3",
          },
        },
      },
      MuiOutlinedInput: {
        root: {
          background: "#FFFFFF",
          border: "0.5px solid #3246D3",
          boxSizing: "border-box",
          boxShadow: "0px 4px 8px rgba(44, 39, 56, 0.04)",
          borderRadius: 6,
          width: "19vw",
          marginTop: "-1.5vh",
          [defaultTheme.breakpoints.down("md")]: {
            "& .MuiOutlinedInput-input": {
              height: "0.7vh",
            },
            width: "25vw",
          },
          [defaultTheme.breakpoints.down("sm")]: {
            width: "auto",
          },
          [defaultTheme.breakpoints.down("xs")]: {
            marginLeft: "2vh",
            width: "65vw",
          },
        },
        notchedOutline: {
          borderColor: "#0b148e",
        },
      },
      MuiPaper: {
        root: {
          backgroundColor: "#F7FAFF",
        },
      },
    },
  })
);
